import { render, staticRenderFns } from "./location-rooms.vue?vue&type=template&id=5ad654f0&scoped=true&"
import script from "./location-rooms.vue?vue&type=script&lang=js&"
export * from "./location-rooms.vue?vue&type=script&lang=js&"
import style0 from "./location-rooms.vue?vue&type=style&index=0&id=5ad654f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad654f0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardTitle})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad654f0')) {
      api.createRecord('5ad654f0', component.options)
    } else {
      api.reload('5ad654f0', component.options)
    }
    module.hot.accept("./location-rooms.vue?vue&type=template&id=5ad654f0&scoped=true&", function () {
      api.rerender('5ad654f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/location-rooms.vue"
export default component.exports